//@ts-nocheck
import { useState, useEffect } from 'react';
import Script from 'next/script';
import Head from 'next/head';
import type { NextPage } from 'next';
import Link from 'next/link';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { MenuWrap } from '../Fblog.styles';
import {
  ContentWrap,
  Content,
  FooterContent,
  GlobalStyle,
  SmallBlockBreaking,
  ExtraSmallBlockBreaking,
  SmallfourBlockBreaking,
  MediumBlockBreakingStories,
  BtnMore,
  ExpTitle
} from './george.styles';
import { LogoWhite } from '@assets/svgs';
import Layout from '@components/Layout';
import Footer from '@components/Footer';
import { BlogItemsBigSingle } from '@components/BlogitemsBigSingle';
import { TopStoryComponent } from '@components/TopStory';
import { SignatureCEO } from '@components/SignatureCEO';
import { CWriting } from '@data/copywriting';
import { Thecopymodal } from '@components/ModalCopy';
import Modal from '@components/Modal';
import Menu from '@components/Menu/index';
import Entrepreneurs from '@components/George/entrepreneurs';
import victory_slogan from '@assets/Alexandra_Victor_Wear.png';
import Daniell_london_logo from '@assets/Daniell_london_logo.png';
import Cover_The_Future_of_Luxury4 from '@assets/Cover_The_Future_of_Luxury4.png';

import Cover_2_legacy_perfume5 from '@assets/Cover_2_legacy_perfume5.png';
import Cover_2_Alignment5 from '@assets/Cover_2_Alignment5.png';
import Cover_2_Cipriani5 from '@assets/Cover_2_Cipriani5.png';
import daniell_hero_desktop from '@assets/daniell_hero_desktop.png';
import daniell_hero_mobile from '@assets/daniell_hero_mobile.png';
import Cover_2_Beyond_Luxury5 from '@assets/Cover_2_Beyond_Luxury5.png';
import Cover_2_Bob5 from '@assets/Cover_2_Bob5.png';
import Cover_2_prairie5 from '@assets/Cover_2_prairie5.png';
import Cover_2_Dress_Code5 from '@assets/Cover_2_Dress_Code5.png';
import Cover_2_Elite_Private3 from '@assets/Cover_2_Elite_Private3.png';
import Cover_2_Libre5 from '@assets/Cover_2_Libre5.png';
import Cover_2_Protocol_DL5 from '@assets/Cover_2_Protocol_DL5.png';
import Cover_2_Global5 from '@assets/Cover_2_Global5.png';
import Cover_2_Executive_Wardrobe5 from '@assets/Cover_2_Executive_Wardrobe5.png';
import Cover_2_Executive_Handbag5 from '@assets/Cover_2_Executive_Handbag5.png';
import Cover_2_Franfance5 from '@assets/Cover_2_Franfance5.png';
import Cover_2_Coat5 from '@assets/Cover_2_Coat5.png';
import Cover_2_Errors5 from '@assets/Cover_2_Errors5.png';
import Cover_2_CEOBrand5 from '@assets/Cover_2_CEOBrand5.png';
import Cover_2_Prestige_Dior5 from '@assets/Cover_2_Prestige_Dior5.png';
import Cover_2_Yourself5 from '@assets/Cover_2_Yourself5.png';
import Cover_2_Between5 from '@assets/Cover_2_Between5.png';
import Cover_2_Details5 from '@assets/Cover_2_Details5.png';
import Cover_2_LaMarina2 from '@assets/Cover_2_LaMarina2.png';
import Cover_2_LaMarina3 from '@assets/Cover_2_LaMarina3.png';
import Cover_2_Beyond_Price4 from '@assets/Cover_2_Beyond_Price4.png';
import Cover_2_Beyond_Price5 from '@assets/Cover_2_Beyond_Price5.png';
import Cover_2_Signature5 from '@assets/Cover_2_Signature5.png';
import Cover_2_HermesKelly5 from '@assets/Cover_2_HermesKelly5.png';
import Cover_2_Sketch4 from '@assets/Cover_2_Sketch4.png';
import Cover_2_Sketch5 from '@assets/Cover_2_Sketch5.png';
import Cover_2_Technical from '@assets/Cover_2_Technical.png';
import Cover_2_Technical3 from '@assets/Cover_2_Technical3.png';
import Cover_2_Cuff4 from '@assets/Cover_2_Cuff4.png';
import Cover_2_Cuff5 from '@assets/Cover_2_Cuff5.png';
import Cover_2_services2 from '@assets/Cover_2_services2.png';
import Cover_2_services3 from '@assets/Cover_2_services3.png';
import Cover_2_Luxury_Digital4 from '@assets/Cover_2_Luxury_Digital4.png';
import Cover_2_Luxury_Digital5 from '@assets/Cover_2_Luxury_Digital5.png';
import Cover_2_Collar3 from '@assets/Cover_2_Collar3.png';
import Cover_2_Collar5 from '@assets/Cover_2_Collar5.png';
import Cover_2_Decisions3 from '@assets/Cover_2_Decisions3.png';
import Cover_2_Decisions4 from '@assets/Cover_2_Decisions4.png';
import Cover_2_Clive4 from '@assets/Cover_2_Clive4.png';
import Cover_2_Clive5 from '@assets/Cover_2_Clive5.png';

import Cover_2_Beyond2 from '@assets/Cover_2_Beyond2.png';
import Cover_2_Beyond4 from '@assets/Cover_2_Beyond4.png';

const George: NextPage = () => {
  const [isEmail, setIsEmail] = useState(false);
  const [isModalopen, setIsmodalopen] = useState(false);
  const [isFashionsOpen, setIsFashionsOpen] = useState(false);
  const router = useRouter();
  const whatAppmsg =
    'Hi George Martins,%0a%0aI would like to talk about my project with you. Could we have a chat about it, please?%0aThank you!%0a%0aMy name:%0aMy Email:%0aMy number:';

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setIsmodalopen(true);
  //   }, 3000);
  //   return () => clearTimeout(timer);
  // }, []);

  const [scroll, setScroll] = useState(false);
  const [gapC] = useState('10px');

  useEffect(() => {
    window.addEventListener('scroll', () => {
      setScroll(window.scrollY > 100);
    });
  }, []);

  return (
    <>
      <GlobalStyle />
      <Layout
        showHeader
        showCopyheader
        animationHeader="header"
        showFashionDesktop
        showMenu
        color="#000"
        email="george.martins@jorgedd.com"
        whatAppmsg="Hi George Martins,%0a%0aI would like to talk about my project with you. Could we have a chat about it, please?%0aThank you!%0a%0aMy name:%0a%0aMy Email:%0a%0aMy number:"
        whatAppLink="I'm looking forward to speak about your project. Click here to connect with me!"
        logo={<LogoWhite />}
      >
        <ContentWrap>
          <div className="sub_wrap">
            <MenuWrap>
              <Menu showCopywritingMenu />
            </MenuWrap>
          </div>
          <Content style={{ maxWidth: '1600px' }}>
            <did
              style={{
                position: 'relative',
                width: '100%',
                height: '100%',
                display: 'block'
              }}
            >
              <Image
                src={daniell_hero_desktop}
                width={600}
                height={1024}
                alt="Ward 4"
                className="heroDesktop"
                style={{
                  width: '100%',
                  maxWidth: '100%',
                  height: 'auto',
                  marginBottom: '7px'
                }}
              />
              <Image
                src={daniell_hero_mobile}
                width={600}
                height={1024}
                alt="Ward 4"
                className="heroMobile"
                style={{
                  width: '100%',
                  maxWidth: '100%',
                  height: 'auto',
                  marginBottom: '7px'
                }}
              />
              <BtnMore
                style={{
                  position: 'absolute',
                  bottom: '40px',
                  columnGap: '0',
                  left: '0',
                  right: '0',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  marginBottom: '0'
                }}
              >
                <Link
                  // href="/editorial/"
                  href="https://danielllondon.jorgedd.com/Dresscode/"
                  className="btn"
                  target="_blank"
                  style={{
                    background: '#fff',
                    color: '#000',
                    textTransform: 'uppercase',
                    maxWidth: '200px',
                    letterSpacing: '1px',
                    border: 0
                  }}
                >
                  Dress Code Engineers
                </Link>
              </BtnMore>
            </did>

            <ExpTitle>The House Reviews</ExpTitle>
            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Image
                src={Cover_2_Beyond2}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
              <Link
                href="https://danielllondon.jorgedd.com/Dresscode/"
                target="_blank"
              >
                <Image
                  src={Cover_The_Future_of_Luxury4}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>

              <Link href={CWriting.landing[304].url} target="_blank">
                <Image
                  src={Cover_2_Beyond4}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
              <Image
                src={CWriting.landing[304].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Image
                src={Cover_2_Collar3}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
              <Link
                href="https://danielllondon.jorgedd.com/Dresscode/"
                target="_blank"
              >
                <Image
                  src={Cover_The_Future_of_Luxury4}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>

              <Link href={CWriting.landing[301].url} target="_blank">
                <Image
                  src={Cover_2_Collar5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
              <Image
                src={CWriting.landing[301].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Image
                src={Cover_2_Cuff4}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
              <Link
                href="https://danielllondon.jorgedd.com/Dresscode/"
                target="_blank"
              >
                <Image
                  src={Cover_The_Future_of_Luxury4}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>

              <Link href={CWriting.landing[298].url} target="_blank">
                <Image
                  src={Cover_2_Cuff5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
              <Image
                src={CWriting.landing[298].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
            </MediumBlockBreakingStories>

            <ExpTitle>Explore our services</ExpTitle>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Image
                src={Cover_2_services2}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
              <Link
                href="https://danielllondon.jorgedd.com/Digital/"
                target="_blank"
              >
                <Image
                  src={Cover_The_Future_of_Luxury4}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>

              <Link href={CWriting.landing[299].url} target="_blank">
                <Image
                  src={Cover_2_services3}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
              <Image
                src={CWriting.landing[299].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
            </MediumBlockBreakingStories>

            <ExpTitle>The Olfactory Dress Code</ExpTitle>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Image
                src={Cover_2_Clive4}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
              <Link
                href="https://danielllondon.jorgedd.com/Perfumes"
                target="_blank"
              >
                <Image
                  src={Cover_2_legacy_perfume5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>

              <Link href={CWriting.landing[303].url} target="_blank">
                <Image
                  src={Cover_2_Clive5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
              <Image
                src={CWriting.landing[303].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Image
                src={Cover_2_Beyond_Price4}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
              <Link
                href="https://danielllondon.jorgedd.com/Perfumes"
                target="_blank"
              >
                <Image
                  src={Cover_2_legacy_perfume5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>

              <Link href={CWriting.landing[293].url} target="_blank">
                <Image
                  src={Cover_2_Beyond_Price5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
              <Image
                src={CWriting.landing[293].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
            </MediumBlockBreakingStories>

            <ExpTitle>Luxury Digital Reviews</ExpTitle>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Image
                src={Cover_2_Decisions3}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
              <Link
                href="https://danielllondon.jorgedd.com/Digital/"
                target="_blank"
              >
                <Image
                  src={Cover_The_Future_of_Luxury4}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>

              <Link href={CWriting.landing[302].url} target="_blank">
                <Image
                  src={Cover_2_Decisions4}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
              <Image
                src={CWriting.landing[302].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Image
                src={Cover_2_Luxury_Digital4}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
              <Link
                href="https://danielllondon.jorgedd.com/Digital/"
                target="_blank"
              >
                <Image
                  src={Cover_The_Future_of_Luxury4}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>

              <Link href={CWriting.landing[300].url} target="_blank">
                <Image
                  src={Cover_2_Luxury_Digital5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
              <Image
                src={CWriting.landing[300].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Image
                src={Cover_2_Technical}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
              <Link
                href="https://danielllondon.jorgedd.com/Digital/"
                target="_blank"
              >
                <Image
                  src={Cover_The_Future_of_Luxury4}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>

              <Link href={CWriting.landing[297].url} target="_blank">
                <Image
                  src={Cover_2_Technical3}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
              <Image
                src={CWriting.landing[297].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
            </MediumBlockBreakingStories>

            <br />
            <Image
              src={Daniell_london_logo}
              width={600}
              height={1024}
              alt="Ward 4"
              style={{
                maxWidth: '190px',
                height: 'auto',
                position: 'relative',
                margin: 'auto'
              }}
            />
            <br />
            <br />
            <BtnMore style={{ marginTop: '0', columnGap: '10px' }}>
              <Link
                href="mailto:daniell.london@jorgedd.com"
                className="btn"
                target="_blank"
                style={{
                  background: '#000',
                  color: '#fff',
                  textTransform: 'uppercase',
                  maxWidth: '220px',
                  letterSpacing: '1px'
                }}
              >
                Request a Private Conversation
              </Link>

              <Link
                href="https://danielllondon.jorgedd.com/"
                className="btn"
                target="_blank"
                style={{
                  textTransform: 'uppercase',
                  maxWidth: '220px',
                  letterSpacing: '1px'
                }}
              >
                Discover Daniell London
              </Link>
            </BtnMore>
            <div className="topText">
              <h2
                className="headlineH2"
                style={{
                  textAlign: 'center',
                  textTransform: 'uppercase',
                  maxWidth: '570px'
                }}
              >
                We Transform Fashion, Lifestyle and Personal Sophistication into
                a Powerful Expression of Who You Are.
              </h2>
              <br />
              {/* <h2
                className="headlineH2"
                style={{ textAlign: 'center', marginTop: 0, maxWidth: '700px' }}
              >
                A private house for women who lead, influence, and require
                precision at the level of identity.
              </h2> */}
            </div>
          </Content>
          <div className="imgWrap">
            <Image
              className="ceo_logo"
              src={victory_slogan}
              width={498}
              height={98}
              alt="CEO_logo"
              style={{ maxWidth: '190px', marginTop: '-30px' }}
            />
          </div>
          <BtnMore style={{ marginBottom: 0 }}>
            <Link
              href="/victorybrading/Signature_Series.pdf"
              className="btn"
              rel="noopener noreferrer"
              target="_blank"
              style={{
                textTransform: 'uppercase',
                letterSpacing: '1px'
              }}
            >
              The Signature Series
            </Link>
          </BtnMore>

          {/* Top Stories */}
          {/* <TopStoryComponent
            thStory
            linkTitle="Read The House Editorial"
            mainStoryTitle={CWriting.landing[246].title}
            mainStoryImg={CWriting.landing[246].img}
            mainStoryUrl={CWriting.landing[246].url}
          /> */}

          {/* <span className="service_title">THE SIGNATURE SERIES</span>
          <SignatureCEO /> */}

          <div>
            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Image
                src={CWriting.landing[296].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
              <Link href={CWriting.landing[296].url} target="_blank">
                <Image
                  src={Cover_2_Sketch5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Link href={CWriting.landing[292].url} target="_blank">
                <Image
                  src={Cover_2_LaMarina3}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
              <Image
                src={CWriting.landing[292].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Image
                src={CWriting.landing[295].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
              <Link href={CWriting.landing[295].url} target="_blank">
                <Image
                  src={Cover_2_HermesKelly5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Link href={CWriting.landing[294].url} target="_blank">
                <Image
                  src={Cover_2_Signature5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
              <Image
                src={CWriting.landing[294].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Image
                src={CWriting.landing[291].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
              <Link href={CWriting.landing[291].url} target="_blank">
                <Image
                  src={Cover_2_Details5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Link href={CWriting.landing[290].url} target="_blank">
                <Image
                  src={Cover_2_Between5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
              <Image
                src={CWriting.landing[290].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Link href={CWriting.landing[289].url} target="_blank">
                <Image
                  src={Cover_2_Yourself5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
              <Image
                src={CWriting.landing[289].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Image
                src={CWriting.landing[288].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
              <Link href={CWriting.landing[288].url} target="_blank">
                <Image
                  src={Cover_2_Prestige_Dior5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Link href={CWriting.landing[287].url} target="_blank">
                <Image
                  src={Cover_2_CEOBrand5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
              <Image
                src={CWriting.landing[287].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Image
                src={CWriting.landing[286].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
              <Link href={CWriting.landing[286].url} target="_blank">
                <Image
                  src={Cover_2_Errors5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Link href={CWriting.landing[285].url} target="_blank">
                <Image
                  src={Cover_2_Coat5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
              <Image
                src={CWriting.landing[285].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Image
                src={CWriting.landing[284].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
              <Link href={CWriting.landing[284].url} target="_blank">
                <Image
                  src={Cover_2_Franfance5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Link href={CWriting.landing[283].url} target="_blank">
                <Image
                  src={Cover_2_Executive_Handbag5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
              <Image
                src={CWriting.landing[283].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Image
                src={CWriting.landing[282].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
              <Link href={CWriting.landing[282].url} target="_blank">
                <Image
                  src={Cover_2_Executive_Wardrobe5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Link href={CWriting.landing[281].url} target="_blank">
                <Image
                  src={Cover_2_Global5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
              <Image
                src={CWriting.landing[281].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Image
                src={CWriting.landing[280].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
              <Link href={CWriting.landing[280].url} target="_blank">
                <Image
                  src={Cover_2_Protocol_DL5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Link href={CWriting.landing[279].url} target="_blank">
                <Image
                  src={Cover_2_Libre5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
              <Image
                src={CWriting.landing[279].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Image
                src={CWriting.landing[278].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
              <Link href={CWriting.landing[278].url} target="_blank">
                <Image
                  src={Cover_2_Elite_Private3}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Link href={CWriting.landing[277].url} target="_blank">
                <Image
                  src={Cover_2_Dress_Code5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
              <Image
                src={CWriting.landing[277].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Image
                src={CWriting.landing[276].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
              <Link href={CWriting.landing[276].url} target="_blank">
                <Image
                  src={Cover_2_prairie5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Link href={CWriting.landing[275].url} target="_blank">
                <Image
                  src={Cover_2_Bob5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
              <Image
                src={CWriting.landing[275].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Image
                src={CWriting.landing[274].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
              <Link href={CWriting.landing[274].url} target="_blank">
                <Image
                  src={Cover_2_Beyond_Luxury5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Link href={CWriting.landing[273].url} target="_blank">
                <Image
                  src={Cover_2_Cipriani5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
              <Image
                src={CWriting.landing[273].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
            </MediumBlockBreakingStories>

            <MediumBlockBreakingStories
              style={{ marginBottom: '7px', columnGap: 0, rowGap: 0 }}
            >
              <Image
                src={CWriting.landing[272].img}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
              />
              <Link href={CWriting.landing[272].url} target="_blank">
                <Image
                  src={Cover_2_Alignment5}
                  width={600}
                  height={1024}
                  alt="Ward 4"
                  style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                />
              </Link>
            </MediumBlockBreakingStories>
          </div>

          <span className="service_title">THE HOUSE OF MARTIN'S</span>
          <SmallfourBlockBreaking style={{ columnGap: gapC }}>
            <Entrepreneurs />
          </SmallfourBlockBreaking>
          <BtnMore>
            <Link
              href="https://medium.com/@themartinshouse"
              className="btn"
              style={{ textTransform: 'uppercase', letterSpacing: '1px' }}
            >
              Read The House Editorial
            </Link>
          </BtnMore>
        </ContentWrap>
        <FooterContent>
          <Footer isClass="footer" />
        </FooterContent>
      </Layout>
      {isEmail && (
        <Thecopymodal showEmailMarketing isClosed={() => setIsEmail(false)} />
      )}
      {isModalopen && (
        <Modal
          newsModal
          subscribeText="We Are Writers"
          addStyle="1px solid #eee"
          onClose={() => setIsmodalopen(false)}
        />
      )}
    </>
  );
};

export default George;
